"use client";

import { motion } from "framer-motion";

interface RejectedIconProps {
  size?: number;
  strokeWidth?: number;
  className?: string;
}

const draw = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: (i: number) => ({
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: {
        delay: i * 0.15,
        type: "spring",
        duration: 1.2,
        bounce: 0.1,
        ease: [0.25, 0.1, 0.25, 1],
      },
      opacity: { delay: i * 0.15, duration: 0.3 },
    },
  }),
};

export function RejectedIcon({
  size = 80,
  strokeWidth = 2,
  className = "",
}: RejectedIconProps) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      initial="hidden"
      animate="visible"
      className={className}
    >
      <title>Rejected Status</title>
      {/* Circle */}
      <motion.circle
        cx="50"
        cy="50"
        r="35"
        stroke="rgb(239 68 68)" // red-500
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        variants={draw}
        custom={0}
      />
      {/* Cross - first line */}
      <motion.line
        x1="38"
        y1="38"
        x2="62"
        y2="62"
        stroke="rgb(239 68 68)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        variants={draw}
        custom={1}
      />
      {/* Cross - second line */}
      <motion.line
        x1="62"
        y1="38"
        x2="38"
        y2="62"
        stroke="rgb(239 68 68)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        variants={draw}
        custom={1.2}
      />
    </motion.svg>
  );
}
